import { useState } from 'react'; // <-- Não esqueça de importar o useState
import './App.css';
import Banner from './presentation/components/Banner';
import Education from './presentation/components/Education';
import Experience from './presentation/components/Experience';
import Footer from './presentation/components/Footer';
import Logo from './presentation/components/Logo';
import Menu from './presentation/components/Menu';
import Projects from './presentation/components/Projects';
import Stacks from './presentation/components/Stacks';
import TextMe from './presentation/components/TextMe';

function App() {
  // Estado global da linguagem (inicia em português)
  const [language, setLanguage] = useState('pt'); 

  const activeSections = {
    header: true,
    banner: true,
    textMe: true,
    stacks: true,
    projects: true,
    experience: true,
    education: true,
    footer: true
  };

  return (
    <div className="App">
      
      {activeSections.header && 
        <header className="App-header">
          <div className="App-header-content">
          <Logo/>
          <Menu language={language} setLanguage={setLanguage} />
          </div>
        </header>
      }
      
      {activeSections.banner && 
        <Banner language={language} setLanguage={setLanguage}/>}

      {activeSections.textMe &&
        <TextMe language={language} setLanguage={setLanguage} />}

      {activeSections.stacks &&
        <Stacks language={language} setLanguage={setLanguage}/>}

      {activeSections.projects &&
        <Projects language={language} setLanguage={setLanguage}/>}

      {activeSections.experience &&
        <Experience language={language} setLanguage={setLanguage}/>}

      {activeSections.education &&
        <Education language={language} setLanguage={setLanguage}/>}

      {activeSections.footer &&
        <Footer language={language} setLanguage={setLanguage}/> }
    </div>
  );
}

export default App;